
export default {
  props: {
    tagList: {
      type: Array,
      required: true
    },
    currentTag: {
      type: String,
      required: ''
    }
  },

  data: function data() {
    return {};
  },


  methods: {
    changeTag: function changeTag(tag) {
      if (this.tagId === tag.id) return;
      this.$emit('get-components', tag);
    }
  }
};